import { Box, Divider, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useGlobalOrganizationContext } from "../../../hooks/useGlobalOrganizationContext";
import { ContactLabels, ContactType } from "../../../model/Contact";
import ManageContactInfo from "../components/ManageContactInfo";

const OrganizationContactInfoSettings: FC<unknown> = () => {
  const org = useGlobalOrganizationContext().organization;

  if (org)
    return (
      <>
        {/* Emails */}
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h1" pb={1}>
              Organization Emails
            </Typography>
          </Grid>

          <Grid
            container
            item
            xs={12}
            borderRadius={"10px"}
            border={"1px solid #aaaaaa"}
            overflow={"hidden"}
            boxShadow={"0px 1px 2px #aaaaaa"}
          >
            <Grid item xs={12}>
              <ManageContactInfo
                organization={org}
                label={ContactLabels.PRIMARY}
                type={ContactType.EMAIL}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <ManageContactInfo
                organization={org}
                label={ContactLabels.BILLING}
                type={ContactType.EMAIL}
              />
            </Grid>
          </Grid>
        </Grid>

        <Box height="40px"></Box>

        {/* Phone */}
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Typography variant="h1" pb={1}>
              Organization Phone Numbers
            </Typography>
          </Grid>
          <Grid
            container
            item
            borderRadius={"10px"}
            overflow={"hidden"}
            border="1px solid #aaaaaa"
            boxShadow={"0px 1px 2px #aaaaaa"}
          >
            <ManageContactInfo
              organization={org}
              label={ContactLabels.PRIMARY}
              type={ContactType.PHONE}
            />

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <ManageContactInfo
              organization={org}
              label={ContactLabels.BILLING}
              type={ContactType.PHONE}
            />
          </Grid>
        </Grid>
      </>
    );
};

export default OrganizationContactInfoSettings;
